import { Identifiable, ProjectResource } from "@planzone/dto";
import { LinkedResource, Linker } from "../linkers/types";
import { HttpClient, HttpMethods } from "../types/httpClient";

function editProjectResource(httpClient: HttpClient, linker: Linker) {
  return (
    resource: Identifiable<ProjectResource>,
    nextResource: ProjectResource,
  ) =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<ProjectResource>>>({
        endpoint: `/projectMembers/${resource.uuid}`,
        method: HttpMethods.PATCH,
        data: {
          role: nextResource.role ? `roles/${nextResource.role.uuid}` : null,
        },
      })
      .then(linker.linkProjectResource);
}

export { editProjectResource };
